import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { ReactComponent as ArrowSvg } from 'assets/img/arrowOpenBlock.svg';
import { ReactComponent as CalendarSvg } from 'assets/img/iconCalendar.svg';
import styles from './SelectedMounth.module.scss';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import ContentLoader from 'react-content-loader';

interface ListMounthTypes {
  name: string;
  key: number;
}

interface SelectedMounthTypes {
  listMounth: any;
  selectedMonth: any;
  total_amount?: number;
  setSelectedMonth: (e: string) => void;
  selectedYear: number;
  setSelectedYear: (year: number) => void;
  showTotal_amount: boolean;
  loading?: boolean;
  setPage?: (page: number) => void;
}

export const NewSelectedMounth: FC<SelectedMounthTypes> = ({
  setSelectedMonth,
  selectedMonth,
  listMounth,
  total_amount,
  selectedYear,
  setSelectedYear,
  showTotal_amount,
  loading = false,
  setPage,
}) => {
  const [show, setShow] = useState(false);

  const prevHandler = () => {
    setPage?.(1);
    if (listMounth.length > 0 && selectedMonth) {
      if (selectedMonth.key === 1) {
        setSelectedYear(selectedYear - 1);
        const decemberMonth = listMounth.find((elem: any) => elem.key === 12);
        setSelectedMonth(decemberMonth.name);
      } else {
        const currentMonth = listMounth.find(
          (elem: any) => elem.key === selectedMonth.key - 1,
        );
        setSelectedMonth(currentMonth.name);
      }
    }
  };

  const nextHandler = () => {
    setPage?.(1);
    if (listMounth.length > 0 && selectedMonth) {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();

      if (
        selectedYear < currentYear ||
        (selectedYear === currentYear && selectedMonth.key < currentMonth)
      ) {
        if (selectedMonth.key === 12) {
          setSelectedYear(selectedYear + 1);
          const januaryMonth = listMounth.find((elem: any) => elem.key === 1);
          setSelectedMonth(januaryMonth.name);
        } else {
          const nextMonth = listMounth.find(
            (elem: any) => elem.key === selectedMonth.key + 1,
          );
          setSelectedMonth(nextMonth.name);
        }
      }
    }
  };

  return (
    <div className={classNames(styles.root)}>
      <div
        onClick={() => setShow(!show)}
        className={classNames(
          styles.root_titleBlock,
          show && styles.root_titleBlock_rotateSvg,
        )}>
        <div onClick={prevHandler} className={styles.leftArrow}>
          <ArrowSvg width={12} height={16} />
        </div>
        <div className={styles.root_title}>
          <CalendarSvg />
          <p>
            {selectedMonth.name}{' '}
            {selectedYear !== new Date().getFullYear() && selectedYear}
          </p>
        </div>
        <div onClick={nextHandler} className={styles.rightArrow}>
          <ArrowSvg width={12} height={16} />
        </div>
      </div>
      {showTotal_amount ? (
        loading ? (
          <p className={classNames(styles.root_price, styles.price)}>
            <span className={styles.price_placeholder}>
              {total_amount ? addSpaceNumber(total_amount) : 0} ₽
            </span>
            <ContentLoader
              speed={2}
              height={18}
              className={styles.price_skeleton}
              backgroundColor={'#FFFFFF'}
              foregroundColor={'#D8E4FB8C'}>
              <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
            </ContentLoader>
          </p>
        ) : (
          <p className={styles.root_price}>
            {total_amount ? addSpaceNumber(total_amount) : 0} ₽
          </p>
        )
      ) : null}
    </div>
  );
};
